import React from "react";

const ActionWrapper = ({ children }) => {
    return (
    <div
     className="
     text-nowrap
     ">
        {children}
    </div>)
};

export default ActionWrapper;